import { useController } from 'react-hook-form';
import { Checkbox } from '@mui/material';

export const makeControlledCheckbox =
  (makeProps) =>
  ({ name, control, ...props }) => {
    const { field } = useController({ name, control });
    return <Checkbox {...props} {...field} {...makeProps(field)} />;
  };
